export default "__VITE_ASSET__241cfee3__"